export const printHtml = (html: string, popupBlockedMessage?: string) => {
  const printWindow = window.open('', '_blank', 'noopener,noreferrer,width=1100,height=900');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.onload = () => {
      printWindow.print();
    };
    return true;
  }

  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.setAttribute('aria-hidden', 'true');

  const cleanup = () => {
    window.setTimeout(() => {
      iframe.remove();
    }, 1000);
  };

  iframe.onload = () => {
    const frameWindow = iframe.contentWindow;
    if (!frameWindow) {
      cleanup();
      if (popupBlockedMessage) window.alert(popupBlockedMessage);
      return;
    }

    frameWindow.focus();
    frameWindow.print();
    cleanup();
  };

  document.body.appendChild(iframe);

  const doc = iframe.contentDocument;
  if (!doc) {
    cleanup();
    if (popupBlockedMessage) window.alert(popupBlockedMessage);
    return false;
  }

  doc.open();
  doc.write(html);
  doc.close();
  return true;
};
